<ion-header class="remove-margin-from-safe-area ion-no-border">
  <ion-toolbar>

    <ion-buttons slot="end">
      <ion-button (click)="closeModal()"><ion-icon color="dark" name="close"></ion-icon></ion-button>
    </ion-buttons>


  </ion-toolbar>
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col style="text-align: center;">
          <h2 class="subheader-regular">{{ ('keys.data.config.change_provider' |
            translate : {Default:'Change Provider'}) || 'Change Provider' }}</h2>
        </ion-col>
      </ion-row>

    </ion-grid>

  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row *ngFor="let client of clients">
      <ion-col *ngIf="client.lastSelected" style="text-align: center;" size="12">
        <ion-item class="card-text-bold" lines="none">
          <ion-label *ngIf="dataService.isProductionBuild">{{client.clientName}}</ion-label>
          <ion-label *ngIf="!dataService.isProductionBuild">{{client.webUrl}}</ion-label>
          <ion-chip style="--background:var(--green-pastel, #7EEA97);--color:var(--Green-shade, #376642);">{{
            ('keys.data.common.active' |
            translate : {Default:'Active'}) || 'Active' }}</ion-chip>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngFor="let client of clients">
      <ion-col *ngIf="!client.lastSelected" style="text-align: center" size="12">
        <ion-item class="card-text-bold" lines="none">
          <ion-label *ngIf="dataService.isProductionBuild">{{client.clientName}}</ion-label>
          <ion-label *ngIf="!dataService.isProductionBuild">{{client.webUrl}}</ion-label>
          <ion-toggle (ionChange)="changeClient($event,client)" color="secondary"></ion-toggle>
          <ion-icon name="trash" (click)="removeClient(client)" *ngIf="!client.lastSelected"></ion-icon>
        </ion-item>


      </ion-col>

    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-button (click)="addClient()" color="primary" expand="block">
          <ion-icon name="add-circle"></ion-icon>{{ ('keys.data.config.add_new_provider' |
          translate : {Default:'Add New Provider'}) || 'Add New Provider' }}
        </ion-button>
      </ion-col>
    </ion-row>

  </ion-grid>

</ion-content>